$bog_ainews_app_feed $bog_ainews_app_page
	app_filters $bog_ainews_app_filters
	app_settings $bog_ainews_app_settings
	app_source $bog_ainews_app_sources
	app_favorites $bog_ainews_app_favorites
	title @ \Feed
	Logo $mol_icon_script_text
	tools /
		<= Summary_all_button $mol_button_major
			title @ \Summary all news
			click? <=> summary_all_click? null
		<= Summary_all_pop $mol_pop
			showed? <=> summary_all_showed? false
			Anchor <= Summary_all_button
			bubble_content /
				<= Summary_all_content $mol_page
					title @ \Summary all news
					tools /
						<= Summary_all_close $mol_button_minor
							title @ \Close
							click? <=> summary_all_close_click? null
					body /
						<= Summary_all_text $mol_paragraph
							title <= summary_all_result \
	body /
		<= Hot_fix $mol_view sub /
			<= Searcher $mol_search
				query? <=> search_word? \
		<= Tabs $mol_deck items <= Categories /
		<= Welcome_block $mol_list rows /
			<= Welcome_block_p1_paragraph $mol_paragraph
				title @ \Empty feed - time to choose some sources!
				dom_name \h4
			<= Welcome_block_p2 $mol_view sub /
				<= Welcome_block_p2_paragraph $mol_link 
					title @ \To do this, go to the Sources page
					uri \#!=sources
	Category_page* $mol_list
		title <= category_title* \blank category title
		rows /
			<= Category_summary_button* $mol_button_major
				title @ \Summary category
				click? <=> category_summary_click*? null
			<= Category_summary_pop* $mol_pop
				showed? <=> category_summary_showed*? false
				Anchor <= Category_summary_button*
				bubble_content /
					<= Category_summary_content* $mol_page
						title @ \Category summary
						tools /
							<= Category_summary_close* $mol_button_minor
								title @ \Close
								click? <=> category_summary_close_click*? null
						body /
							<= Category_summary_text* $mol_paragraph
								title <= category_summary_result* \
			<= Items* $mol_list rows <= articles* /
	- <= Spoiler $mol_expander
		label / \Murder is..
		content / \majordomo
		Tools <= Spoiler_tools $mol_view
			sub /
				<= Lock_icon $mol_icon_lock
	Article* $mol_expander
		expanded? <=> openned_post*? false
		label / <= article_title* \
		content /
			<= Article_thumbnail* $bog_ainews_app_feed_img
				src <= article_image_src* /
				alt <= article_title*
				width 192
				height 108
			- <= Article_title* $bog_ainews_app_feed_title
				line_height <= font_size_value* 7
				title <= article_title* \
			<= Article_description_summary_button* $mol_button_minor
				title @ \Summary this
				click? <=> summary_description_click*? null
			<= Article_description* $mol_paragraph
				title <= article_description* \
		Tools <= Spoiler_tools* $mol_view
			sub /
				<= Article_link* $mol_link
					title @ \Open link
					target <= open_in_new_tab* \_self
					uri_toggle <= article_link* \
				<= Article_translated_link* $mol_link
					title @ \Open translated link
					target <= open_in_new_tab*
					uri_toggle <= article_translated_link* \
				<= Article_translate_text* $mol_button_minor
					title @ \Translate
					- enabled <= article_translate_enable true
					click? <=> translate_click*? null
				<= Favorite* $mol_check_icon
					Icon <= Base_icon* $mol_icon_cards_heart
					checked? <=> base_checked*? false
$bog_ainews_app_feed_title $mol_paragraph
	style *
		^
		font-size <= font_size_title \1.22rem
